var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Information_i__Button",
  "data-name": "Information(i)_Button",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "i_Button_Circle",
  fill: "none",
  stroke: "#898989",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.5,
  fill: "none"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "i_Letter_ibutton",
  transform: "translate(-120 -704)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icomponent2",
  transform: "translate(127 707)",
  fill: "none",
  stroke: "#898989",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 0.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "icomponent1",
  transform: "translate(127.25 710)",
  fill: "none",
  stroke: "#898989",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 6,
  rx: 0.35,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 0.5,
  height: 5,
  rx: 0.15,
  fill: "none"
})))));
export default __webpack_public_path__ + "static/media/TooltipIcon.66a6f3f4.svg";
export { SvgComponent as ReactComponent };